import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\GetScheduledTasksController::__invoke
* @see app/Http/Controllers/SAManagement/GetScheduledTasksController.php
* @route '/api/sa-management/command-runner/schedule'
*/
const GetScheduledTasksController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScheduledTasksController.url(options),
    method: 'get',
})

GetScheduledTasksController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/command-runner/schedule',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SAManagement\GetScheduledTasksController::__invoke
* @see app/Http/Controllers/SAManagement/GetScheduledTasksController.php
* @route '/api/sa-management/command-runner/schedule'
*/
GetScheduledTasksController.url = (options?: RouteQueryOptions) => {
    return GetScheduledTasksController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\GetScheduledTasksController::__invoke
* @see app/Http/Controllers/SAManagement/GetScheduledTasksController.php
* @route '/api/sa-management/command-runner/schedule'
*/
GetScheduledTasksController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScheduledTasksController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SAManagement\GetScheduledTasksController::__invoke
* @see app/Http/Controllers/SAManagement/GetScheduledTasksController.php
* @route '/api/sa-management/command-runner/schedule'
*/
GetScheduledTasksController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScheduledTasksController.url(options),
    method: 'head',
})

export default GetScheduledTasksController